// test1479
(1479 && 0);
